import React, { useMemo } from 'react';
import { useUser } from '@clerk/clerk-react';

import FeedbackListPage from './FeedbackListPage';

const RAW_ALLOWLIST = (process.env.REACT_APP_ADMIN_EMAIL_WHITELIST || '')
  .split(',')
  .map((value) => value.trim().toLowerCase())
  .filter(Boolean);

const ADMIN_EMAILS = RAW_ALLOWLIST.filter((entry) => entry.includes('@'));
const ADMIN_IDS = RAW_ALLOWLIST.filter((entry) => !entry.includes('@'));

const AdminFeedbackPage = () => {
  const { user } = useUser();
  const primaryEmail = user?.primaryEmailAddress?.emailAddress?.toLowerCase();
  const clerkId = user?.id?.toLowerCase();

  const isConfigured = RAW_ALLOWLIST.length > 0;
  const isAuthorized = useMemo(() => {
    if (!isConfigured || !(primaryEmail || clerkId)) {
      return false;
    }
    return ADMIN_EMAILS.includes(primaryEmail) || ADMIN_IDS.includes(clerkId);
  }, [primaryEmail, clerkId, isConfigured]);

  if (!isConfigured) {
    return (
      <div className="min-h-screen bg-gray-950 text-gray-200 flex items-center justify-center px-6">
        <div className="max-w-xl space-y-4 text-center">
          <p className="text-2xl font-semibold text-white">Admin access not configured</p>
          <p className="text-gray-400">
            Set <code className="text-blue-300">REACT_APP_ADMIN_EMAIL_WHITELIST</code> to a comma-separated list of admin
            emails so the admin console can enforce access controls.
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthorized) {
    return (
      <div className="min-h-screen bg-gray-950 text-gray-200 flex items-center justify-center px-6">
        <div className="max-w-lg space-y-4 text-center">
          <p className="text-2xl font-semibold text-white">Restricted area</p>
          <p className="text-gray-400">
            Your account is not in the admin allowlist. If you believe this is an error, please contact the Runium team.
          </p>
        </div>
      </div>
    );
  }

  return <FeedbackListPage />;
};

export default AdminFeedbackPage;

